import { render } from "./LeftList.vue?vue&type=template&id=490db5fe&scoped=true"
import script from "./LeftList.vue?vue&type=script&lang=js"
export * from "./LeftList.vue?vue&type=script&lang=js"

import "./LeftList.vue?vue&type=style&index=0&id=490db5fe&scoped=scoped&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490db5fe"]])

export default __exports__